module.exports = __webpack_public_path__ + "img/8.1aac3142.png";